// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2_Ahk","content":"LayoutSettings_content__2FLeB"};